import React, { forwardRef } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default function ActionsMenu({ items, align = 'right' }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative inline-block" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="w-9 h-9 rounded-full border border-border-lines flex items-center justify-center hover:bg-background bg-white"
          >
            <UIcons.UilEllipsisV className="text-secondary" size={16} />
          </button>

          {
            open && (
              <ul className={`absolute ${align === 'right' ? 'right-0' : 'left-0'} top-11 z-20 w-56 bg-white border border-border-lines rounded-xl shadow-lg py-2 divide-y divide-dashed divide-border-lines text-left`}>
                {
                  items.map(({ key, icon: Icon, label, onClick, danger, disabled }) => (
                    <li key={key}>
                      <button
                        type="button"
                        disabled={disabled}
                        className={`w-full flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-background text-left disabled:opacity-50 ${danger ? 'text-danger' : 'text-dark-blue'}`}
                        onClick={() => { handleClick(); onClick() }}
                      >
                        <Icon size={16} className={danger ? 'text-danger' : 'text-secondary'} /> {label}
                      </button>
                    </li>
                  ))
                }
              </ul>
            )
          }
        </div>
      ))}
    />
  )
}
